module.exports = __webpack_public_path__ + "assets/img/left-title-open-61362566.png";